import React, { lazy, Suspense } from "react";

import { Routes, Route } from "react-router-dom";

import Loading from "./pages/Loading";
const Login = lazy(() => import("./pages/Login"));
const Callback = lazy(() => import("./pages/Callback"));
const Logout = lazy(() => import("./pages/Logout"));
const Portal = lazy(() => import("./pages/Portal"));
const NotFound = lazy(() => import("./pages/NotFound"));

function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          exact
          path="/"
          element={
            <Suspense fallback={<Loading />}>
              <Login />
            </Suspense>
          }
        ></Route>
        <Route
          exact
          path="/callback"
          element={
            <Suspense fallback={<Loading />}>
              <Callback />
            </Suspense>
          }
        />
        <Route
          exact
          path="/logout"
          element={
            <Suspense fallback={<Loading />}>
              <Logout />
            </Suspense>
          }
        />
        <Route
          exact
          path="/portal"
          element={
            <Suspense fallback={<Loading />}>
              <Portal />
            </Suspense>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
